import * as types from './mutation_types'

export default {
  [types.SET_PLAYLISTS](state, payload) {
    state.playlists = payload
  }
}
